module.exports = __webpack_public_path__ + "Rutan-Medium.woff2";